import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { PageGrid } from './PageGrid';
import { FeatureArticleSmall } from './feature/FeatureArticleSmall';
import type { ArticleRow } from '../../../shared/schemas/article';

interface ProductFeaturesSectionProps {
  articles: ArticleRow[];
}

export function ProductFeaturesSection({ articles }: ProductFeaturesSectionProps) {
  if (articles.length === 0) return null;

  return (
    <PageGrid as="section" className="w-full">
      <h2 className="col-span-full text-h2 text-text-primary">
        Arvid can do a lot
      </h2>

      <div className="col-span-full grid grid-cols-1 gap-6 md:grid-cols-2">
        {articles.map((article) => (
          <FeatureArticleSmall key={article.slug} article={article} variant="featured" />
        ))}
      </div>

      <a href="/features" className="site-btn-secondary site-btn-md col-span-full">
        Browse all features
        <ArrowUpRight size={14} />
      </a>
    </PageGrid>
  );
}
